/**
@ngdoc directive
@name listingTile

@description

*/

(function() {
    'use strict';

    var listingTile = function($translate, $templateCache) {
        return {
            restrict: "EA",
            scope: true,
            bindToController: {
                /*  '@' Text binding  '=' Two-way binding  '&' Method binding  '<' One-way binding  */
                tileData: '<'
            },
            controllerAs: 'ctrl',
            controller: function() {
                this.getBadgeStatusClass = function(status) {
                    if (!status || !status.label) return ''
                    var statusLabel = status.label.trim().toLowerCase()
                      .replace(/ /g, '-')
                      .replace(/--+/g, '-')
                    if (statusLabel.startsWith('stop-listed')) return 'stop-listed'
                    if (statusLabel.startsWith('restricted')) return 'restricted'
                    return statusLabel
                }
            },
            replace: true,
            transclude: false,
            template: $templateCache.get('components/listing/listingTile.html'),
            link: function(scope, element, attrs) {
                //console.log('listing Tile',scope, element, attrs);
            }
        };
    };
    listingTile.$inject = ['$translate', '$templateCache'];
    angular.module('app').directive('listingTile', listingTile);

}());